<template>
  <div id="app">
    <div v-wechat-title="$route.meta.title"></div>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App'
};
</script>
<link rel="stylesheet" href="https://static2.qcplay.com/page-color/color.css">
<style>
#app {
  position: relative;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  background: #f8f8f8;
}
.v-modal {
  z-index: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue